import styled from 'styled-components';

import PrebookingsSection from './component';

export default styled(PrebookingsSection)`
  width: 100%;
  max-width: 1400px;
  margin: 32px auto;
  padding: 0 16px;

  .loading {
    display: block;
    margin: 0 auto;
  }
`;
